import * as React from 'react';
import CalendarBook from '../../../../types/CalendarBook';
import { getDatePeriod, MOBILE_MAX_WIDTH } from '../../../../utils';
import './BookChip.css';
import { parseISO } from 'date-fns';
import { LibraryCard, CardPropertyType, CardType } from '../../../../types/LibraryCard';
import MediaQuery from 'react-responsive';
import cn from 'classnames';

interface Props {
	card: LibraryCard;
	isSelected?: boolean
	onClick?: () => void;
	className?: string;
	customPeriod?: string;
}

const BookChip: React.FunctionComponent<Props> = ({ card, onClick, isSelected, className, customPeriod }) => {
	const datePeriod = React.useMemo(() => {
		if (customPeriod) {
			return customPeriod
		}

		if (card.cardType === CardType.AlreadyRead && card.history.length > 0) {
			return getDatePeriod(card.history[0].startDate, card.history[0].finishDate)
		}

		return getDatePeriod(
			parseISO(card.properties[CardPropertyType.DateBegin]),
			card.properties[CardPropertyType.DateFinish] ? parseISO(card.properties[CardPropertyType.DateFinish]) : null,
			null,
			null,
			card.cardType === CardType.WantRead
		)
	}, [card.properties[CardPropertyType.DateBegin], card.properties[CardPropertyType.DateFinish], customPeriod]);

	return (
		<div
			className={cn("book-chip", className, {
				"book-chip_selected": isSelected,
				[`book-chip_${card.color}`]: card.color,
			})}
			onClick={() => onClick()}
		>
			<div className="book-chip__image">
				<img src={card.book.image} />
			</div>

			<div className="book-chip__details">
				<MediaQuery minWidth={MOBILE_MAX_WIDTH}>
					<div className="book-chip__name">{card.book.name}</div>

					<div className="book-chip__dates">
						{datePeriod ? `📆 ${datePeriod}` : ""}
					</div>
				</MediaQuery>

				<MediaQuery maxWidth={MOBILE_MAX_WIDTH}>
					<div className="book-chip__info">
						<div className="book-chip__name">
							{card.cardType === CardType.ReadNow && "▶ "}
							{card.book.name}
						</div>

						<div className="book-chip__author">{card.book.author}</div>
					</div>

					<div className="book-chip__dates">
						{datePeriod ? `📆 ${datePeriod}` : ""}
					</div>
				</MediaQuery>
			</div>
		</div>
	);
};

export default BookChip;
